module.exports = __webpack_public_path__ + "img/obs_snow_5.be414822.svg";